import IzzyCheckingGif from '@/assets/images/izzy/checking.gif'
import { cn } from '@/lib/utils'
import { IzzySpeechBubble } from '../speech-bubble'

interface IzzyCheckingProps {
  className?: string
}

export const IzzyChecking = ({ className }: IzzyCheckingProps) => {
  return (
    <div className={cn('select-none', className)}>
      <img src={IzzyCheckingGif} alt="Izzy analisando histórico acadêmico" />
      <div>
        <IzzySpeechBubble className="absolute w-60 left-40 bottom-38">
          Beleza, deixa eu dar uma olhada no seu histórico rapidinho...
        </IzzySpeechBubble>
      </div>
    </div>
  )
}
